// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
#content:has(._settingsApp_vhsQ3) {
	margin: 0;
	width: 100%;
	height: 100%;
}
`, "",{"version":3,"sources":["webpack://./apps/settings/src/views/SettingsApp.vue"],"names":[],"mappings":";AAmBA;CACA,SAAA;CACA,WAAA;CACA,YAAA;AACA","sourcesContent":["<!--\n  - SPDX-FileCopyrightText: 2018 Nextcloud GmbH and Nextcloud contributors\n  - SPDX-License-Identifier: AGPL-3.0-or-later\n-->\n\n<template>\n\t<NcContent :class=\"$style.settingsApp\" appName=\"settings\">\n\t\t<SettingsNavigation />\n\t\t<SettingsContentWrapper />\n\t</NcContent>\n</template>\n\n<script setup lang=\"ts\">\nimport NcContent from '@nextcloud/vue/components/NcContent'\nimport SettingsContentWrapper from './SettingsContentWrapper.vue'\nimport SettingsNavigation from './SettingsNavigation.vue'\n</script>\n\n<style module>\n:global(#content):has(.settingsApp) {\n\tmargin: 0;\n\twidth: 100%;\n\theight: 100%;\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"settingsApp": `_settingsApp_vhsQ3`
};
export default ___CSS_LOADER_EXPORT___;
